import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NotificationService } from './notification';
import { LoaderService } from './loader';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private http = inject(HttpClient);
  private baseUrl = environment.apiBaseUrl;
  private notify = inject(NotificationService);
   private readonly loaderService = inject(LoaderService);

  get<T>(endpoint: string,show_loader?:boolean, options?: { headers?: HttpHeaders; params?: HttpParams },): Observable<T> {
     if(show_loader) this.loaderService.showLoader();
    return this.http.get<T>(`${this.baseUrl}${endpoint}`, options).pipe(
      catchError(this.handleError),
      finalize(() =>this.loaderService.hideLoader())
    );
  }

  post<T>(endpoint: string, body: any, options?: { headers?: HttpHeaders; params?: HttpParams }): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}${endpoint}`, body, options).pipe(
      catchError(this.handleError)
    );
  }

  put<T>(endpoint: string, body: any, options?: { headers?: HttpHeaders; params?: HttpParams }): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}${endpoint}`, body, options).pipe(
      catchError(this.handleError)
    );
  }

  delete<T>(endpoint: string, options?: { headers?: HttpHeaders; params?: HttpParams }): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}${endpoint}`, options).pipe(
      catchError(this.handleError)
    );
  }

  // Method for downloading files as blob
  downloadFile(endpoint: string): Observable<any> {
    return this.http.get(`${this.baseUrl}${endpoint}`, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      catchError(this.handleError),
      finalize(() => this.loaderService.hideLoader())
    );
  }

  private handleError = (error: any) => {
    let message = 'Something went wrong.';
    if (error?.error?.message) {
      message = error.error.message;
    }
    this.notify.show(message, 'danger');
    console.error('API Error:', error);
    return throwError(() => error);
  };
}
